import { OpenAPI } from '@acme/api';
import '@acme/domains/styles';
import '@acme/features/styles';
import { AdminPage } from '@pages/AdminPage';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

OpenAPI.BASE = import.meta.env.VITE_API_BASE;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AdminPage />
  </React.StrictMode>
);
